import Accordions from './accordions'
import Heights from './matchHeight'
import Sliders from './sliders'
import Filter from './filters'
import Menu from './menu'
import Tabs from "./tabs"
import Video from "./video"
import Map from './map'

window.addEventListener('DOMContentLoaded', () => {
	Heights()
	Sliders()
	Filter()
	Menu()
	Video()
	Map();

	// Default Accordions
	const accordionSections = document.querySelectorAll('[data-accordions]')

	if (accordionSections.length) {
		accordionSections.forEach(accordions => {
			new Accordions(accordions, '[data-accordion]', true)
		})
	}

	// Default Tabs
	const tabs = document.querySelectorAll('[data-tabs]')

	if (tabs.length) {
		tabs.forEach(tab => {
			new Tabs(tab)
		})
	}
})
